import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useState } from 'react';

ViewJSONDailog.propTypes = {
  data: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  handleClose: PropTypes.func.isRequired,
};

export default function ViewJSONDailog({ handleClose, data }) {
  const [copySuccess, setCopySuccess] = useState('');

  // Parse and pretty-print the data
  let prettyData = '';
  try {
    if (typeof data === 'string') {
      // Try to parse string as JSON
      const parsed = JSON.parse(data);
      prettyData = JSON.stringify(parsed, null, 2);
    } else if (typeof data === 'object' && data !== null) {
      prettyData = JSON.stringify(data, null, 2);
    } else {
      prettyData = String(data);
    }
  } catch (err) {
    // If parsing fails, just display the raw string
    prettyData = data;
  }

  const handleCopy = () => {
    navigator.clipboard.writeText(prettyData).then(() => {
      setCopySuccess('Copied!');
      setTimeout(() => setCopySuccess(''), 2000);
    });
  };

  return (
    <Dialog
      open
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          maxHeight: '80vh',
        },
      }}
    >
      <DialogTitle>Print JSON Data</DialogTitle>
      <DialogContent dividers>
        <DialogContentText sx={{ mb: 2 }}>
          Printed Payload Data
        </DialogContentText>
        <Box
          component="pre"
          sx={{
            backgroundColor: '#f5f5f5',
            borderRadius: 1,
            p: 2,
            fontFamily: 'source-code-pro, monospace',
            fontSize: 14,
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            maxHeight: '50vh',
            overflowY: 'auto',
          }}
        >
          {prettyData}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button variant="contained" onClick={handleCopy}>
          Copy Payload
        </Button>
        {copySuccess && (
          <Typography
            variant="body2"
            color="success.main"
            sx={{ ml: 2, userSelect: 'none' }}
          >
            {copySuccess}
          </Typography>
        )}
      </DialogActions>
    </Dialog>
  );
}
